(function () {
    function getCookie(cname) {
        var name = cname + "=";
        var ca = (window.document.cookie || '').split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    //add default header for all requests.
    XMLHttpRequest.prototype.originalSend = XMLHttpRequest.prototype.send;
    var customSend = function (vData) {
        var xsrfToken = getCookie('AF-TOKEN');
        if (xsrfToken) {
            this.setRequestHeader('X-AF-TOKEN', xsrfToken);
        }
        this.originalSend(vData);
    };
    XMLHttpRequest.prototype.send = customSend;
})();